/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { organizationTypeIdGet } from '../fn/organization-type/organization-type-id-get';
import { OrganizationTypeIdGet$Params } from '../fn/organization-type/organization-type-id-get';
import { OrganizationTypeModel } from '../models/organization-type-model';
import { OrganizationTypeModelSearchResultModel } from '../models/organization-type-model-search-result-model';
import { organizationTypePost } from '../fn/organization-type/organization-type-post';
import { OrganizationTypePost$Params } from '../fn/organization-type/organization-type-post';
import { organizationTypeSearchOrganizationTypePost } from '../fn/organization-type/organization-type-search-organization-type-post';
import { OrganizationTypeSearchOrganizationTypePost$Params } from '../fn/organization-type/organization-type-search-organization-type-post';

@Injectable({ providedIn: 'root' })
export class MDIOrganizationTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationTypeSearchOrganizationTypePost()` */
  static readonly OrganizationTypeSearchOrganizationTypePostPath = '/OrganizationType/SearchOrganizationType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTypeSearchOrganizationTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationTypeSearchOrganizationTypePost$Response(params?: OrganizationTypeSearchOrganizationTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationTypeModelSearchResultModel>> {
    return organizationTypeSearchOrganizationTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTypeSearchOrganizationTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationTypeSearchOrganizationTypePost(params?: OrganizationTypeSearchOrganizationTypePost$Params, context?: HttpContext): Observable<OrganizationTypeModelSearchResultModel> {
    return this.organizationTypeSearchOrganizationTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<OrganizationTypeModelSearchResultModel>): OrganizationTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `organizationTypeIdGet()` */
  static readonly OrganizationTypeIdGetPath = '/OrganizationType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTypeIdGet$Response(params: OrganizationTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<OrganizationTypeModel>> {
    return organizationTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationTypeIdGet(params: OrganizationTypeIdGet$Params, context?: HttpContext): Observable<OrganizationTypeModel> {
    return this.organizationTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<OrganizationTypeModel>): OrganizationTypeModel => r.body)
    );
  }

  /** Path part for operation `organizationTypePost()` */
  static readonly OrganizationTypePostPath = '/OrganizationType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationTypePost$Response(params?: OrganizationTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return organizationTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationTypePost(params?: OrganizationTypePost$Params, context?: HttpContext): Observable<string> {
    return this.organizationTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
